// import { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { AuthProvider as OidcAuthProvider } from 'react-oidc-context';
import 'bootstrap/dist/css/bootstrap.min.css';
// import Loading from '@spark/ui-components/components/Loading';
import Router from './Router';
import ScrollToTop from './ScrollToTop';
import GlobalStyles from './globalStyles';
import NotificationStyles from './notificationStyles';
import { AuthProvider } from '@/context/AuthContext';
import { PermissionsProvider } from '@/context/PermissionsContext';
import { MenuProvider } from '@/context/MenuContext';
import { getOidcConfig } from '@/config/cognito';

const App = () => {

// Foi retirado o loading, pois estava bugando pra iniciar o form do login.
/* const [isLoading, setIsLoading] = useState(true);
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    const handleLoad = () => {
      setIsLoading(false);
      setTimeout(() => setIsLoaded(true), 500);
    };

    window.addEventListener('load', handleLoad);
    return () => window.removeEventListener('load', handleLoad);
  }, []); */
  let oidcConfig;

  try {
    oidcConfig = getOidcConfig();
  } catch (error) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px',
          background: '#f5f7fb',
          color: '#1f2a44',
          fontFamily: 'Roboto, sans-serif',
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: '560px',
            background: '#fff',
            borderRadius: '12px',
            boxShadow: '0 12px 32px rgba(31, 42, 68, 0.12)',
            padding: '32px',
          }}
        >
          <h2 style={{ marginTop: 0, marginBottom: '16px' }}>Configuração de autenticação inválida</h2>
          <p style={{ margin: 0, lineHeight: 1.5 }}>
            {error.message}
          </p>
        </div>
      </div>
    );
  }

  return <BrowserRouter>
      <OidcAuthProvider {...oidcConfig}>
        <AuthProvider>
          <PermissionsProvider>
            <MenuProvider>
              <ScrollToTop>
                {/* {!isLoaded && isLoading && <Loading />} */}
                <ThemeProvider theme={{
                mode: 'light',
                direction: 'ltr'
              }}>
                  <NotificationStyles />
                  <GlobalStyles />
                  <Router />
                </ThemeProvider>
              </ScrollToTop>
            </MenuProvider>
          </PermissionsProvider>
        </AuthProvider>
      </OidcAuthProvider>
    </BrowserRouter>;
};

export default App;
